/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
} from "reactstrap";
import ProductSelection from '../components/Store/ProductSelection.js';

const StoreView = ({ guuid, qrColor, logoColor, friendlyName, shortId }) => {

  return (
    <Container fluid className="mt-6 mb-3">
      <Row className="justify-content-center">
        <h1>The Quill Store</h1>
      </Row>
      <Row className="justify-content-center">  
        <Row className="justify-content-center">
          <ProductSelection guuid={guuid} qrColor={qrColor} logoColor={logoColor} friendlyName={friendlyName} shortId={shortId} />
        </Row>
      </Row>
    </Container> 
  );
}


export default StoreView;
